import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

// codigo que permite manter o login do utilizador quando se faz refresh de uma pagina
// caso contrario ao fazer refresh a aplicação pedia sempre o login

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, setAuth } = useAuth();

    useEffect(() => {
        console.log(`PersistLogin 1 > useEffect`);
        //console.log(`PersistLogin 1A > auth?.accessToken: `, auth.accessToken);

        const verifyRefreshToken = async () => {
            console.log(`PersistLogin 2 > verifyRefreshToken`)
            try {
                await refresh();
            }
            catch (err) {
                console.error("Refresh token verification failed:", err);
                setAuth({
                    isAuthenticated: false,
                    user: null,
                    user_id: null,
                    group_id: null,
                    group_name: null,
                    permissions: [],
                });
            }
            finally {
                setIsLoading(false);
            }
        }

        // If the user is not authenticated, verify the refresh token
        if (!auth?.isAuthenticated) {
            verifyRefreshToken();
        } else {
            setIsLoading(false); // If already authenticated, skip verification
        }
    }, [auth?.isAuthenticated, refresh, setAuth]); // Add all dependencies here

    useEffect(() => {
        console.log(`PersistLogin > isLoading: ${isLoading}`);
        //console.log(`PersistLogin > aT: ${JSON.stringify(auth?.accessToken)}`);

    }, [isLoading])


    return (
        <>
            {isLoading
                ? <p>Loading...</p>
                : <Outlet />
            }
        </>
    )
}

export default PersistLogin
